/* eslint-disable react-hooks/exhaustive-deps */
import {useMemo} from 'react'
import {KTSVG} from '../../../../../_dashboard/helpers'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {useLang} from '../../../../../_dashboard/i18n/Metronici18n'
import {fetchAllOptions} from '../core/fetchAllOptions'
import {useToursListFilters} from '../core/ToursListFiltersProvider'

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0

const resolveCategoryTitle = (category: any, language: string): string => {
  const translatedTitle = category.translations?.find((t: any) => t.language === language)?.title
  return translatedTitle || category.title || ''
}

const resolveTypeTitle = (type: any, language: string): string => {
  const translatedTitle = type.translations?.find((t: any) => t.language === language)?.title
  return translatedTitle || type.title || ''
}

const ToursListSearchComponent = () => {
  const intl = useIntl()
  const lang = useLang()
  const {
    searchInput,
    setSearchInput,
    statusFilter,
    setStatusFilter,
    categoryFilter,
    setCategoryFilter,
    cityFilter,
    setCityFilter,
    typeFilter,
    setTypeFilter,
  } = useToursListFilters()

  const {data: categories = [], isLoading: categoriesLoading} = useQuery(
    ['tour-list-categories', lang],
    () => fetchAllOptions('/tour-categories'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const {data: cities = [], isLoading: citiesLoading} = useQuery(
    ['tour-list-cities', lang],
    () => fetchAllOptions('/tour-cities'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const {data: tourTypes = [], isLoading: typesLoading} = useQuery(
    ['tour-list-types', lang],
    () => fetchAllOptions('/tour-types'),
    {cacheTime: 60 * 60 * 1000, staleTime: 30 * 60 * 1000},
  )

  const categoryOptions = useMemo(
    () =>
      categories.filter(
        (category: any) =>
          isNonEmptyString(category?._id) && isNonEmptyString(resolveCategoryTitle(category, lang)),
      ),
    [categories, lang],
  )

  const cityOptions = useMemo(
    () => cities.filter((city: any) => isNonEmptyString(city?._id) && isNonEmptyString(city?.name)),
    [cities],
  )

  const typeOptions = useMemo(
    () =>
      tourTypes.filter(
        (type: any) => isNonEmptyString(type?._id) && isNonEmptyString(resolveTypeTitle(type, lang)),
      ),
    [tourTypes, lang],
  )

  return (
    <div className='bo-filters d-flex flex-wrap gap-3 align-items-center flex-grow-1'>
      <div className='position-relative d-flex align-items-center'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-2 position-absolute ms-4'
        />
        <input
          type='text'
          className='form-control form-control-solid w-200px w-lg-250px ps-12'
          placeholder={intl.formatMessage({id: 'COMMON.SEARCH'})}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>

      <select
        className='form-select form-select-solid w-auto min-w-140px'
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value=''>{intl.formatMessage({id: 'COMMON.ALL_STATUSES'})}</option>
        <option value='draft'>{intl.formatMessage({id: 'BLOG.DRAFT'})}</option>
        <option value='published'>{intl.formatMessage({id: 'BLOG.PUBLISHED'})}</option>
      </select>

      <select
        className='form-select form-select-solid w-auto min-w-160px'
        value={categoryFilter}
        onChange={(e) => setCategoryFilter(e.target.value)}
        disabled={categoriesLoading}
      >
        <option value=''>
          {intl.formatMessage({id: 'TOUR.FIELDS.CATEGORY'})} — {intl.formatMessage({id: 'ECOMMERCE.COMMON.ALL'})}
        </option>
        {categoryOptions.map((category: any) => (
          <option key={category._id} value={category._id}>
            {resolveCategoryTitle(category, lang)}
          </option>
        ))}
      </select>

      <select
        className='form-select form-select-solid w-auto min-w-140px'
        value={cityFilter}
        onChange={(e) => setCityFilter(e.target.value)}
        disabled={citiesLoading}
      >
        <option value=''>
          {intl.formatMessage({id: 'TOUR.FIELDS.CITY'})} — {intl.formatMessage({id: 'ECOMMERCE.COMMON.ALL'})}
        </option>
        {cityOptions.map((city: any) => (
          <option key={city._id} value={city._id}>
            {city.name}
          </option>
        ))}
      </select>

      <select
        className='form-select form-select-solid w-auto min-w-160px'
        value={typeFilter}
        onChange={(e) => setTypeFilter(e.target.value)}
        disabled={typesLoading}
      >
        <option value=''>
          {intl.formatMessage({id: 'TOUR.FIELDS.TYPE'})} — {intl.formatMessage({id: 'ECOMMERCE.COMMON.ALL'})}
        </option>
        {typeOptions.map((type: any) => (
          <option key={type._id} value={type._id}>
            {resolveTypeTitle(type, lang)}
          </option>
        ))}
      </select>
    </div>
  )
}

export {ToursListSearchComponent}
